import { FC, useState, useCallback, useEffect } from 'react';
import { Select, MenuItem, InputLabel, FormControl, Grid } from '@mui/material';
import { UserService } from 'services';
import { Button, TextField } from 'components';

interface ISearch {
  setVets: Function;
  currentPage: number;
  setMaxPage: Function;
  setLoading: Function;
}

export const SearchBar: FC<ISearch> = ({
  setVets,
  currentPage,
  setMaxPage,
  setLoading,
}) => {
  const [bond, setBond] = useState('');
  const [query, setQuery] = useState('');
  const [inPage, setInPage] = useState(currentPage);

  const handleChangeBond = (event: any) => {
    setBond(event.target.value);
  };

  const handleChangeQuery = (event: any) => {
    setQuery(event.target.value);
  };

  const getVets = useCallback(
    async (page: number, filter: string, bond: string) => {
      const maxPg = await UserService.getVetMaxPage(10, filter, bond);
      if (maxPg.status === 200) {
        if (maxPg.data.maxPage) {
          setMaxPage(parseInt(maxPg.data.maxPage));
        }
      }

      const vets = await UserService.getVets(page, 10, filter, bond);
      if (vets.status === 200) {
        return vets.data;
      } else {
        return [];
      }
    },
    [setMaxPage]
  );

  const getVetsCb = useCallback(
    async (force = false) => {
      if (inPage !== currentPage || force === true) {
        const vets = await getVets(currentPage, query, bond);
        setVets(vets);
      }
    },
    [setVets, inPage, query, currentPage, bond, getVets]
  );

  useEffect(() => {
    getVets(1, '', '').then((vets) => {
      setLoading(false);
      setVets(vets);
    });
  }, [setVets, getVets, setLoading]);

  useEffect(() => {
    setInPage(currentPage);
  }, [currentPage, setInPage, getVetsCb]);

  useEffect(() => {
    getVetsCb();
  }, [setInPage, getVetsCb]);

  return (
    <Grid container spacing={1} justifyContent="flex-end">
      <Grid item>
        <TextField
          id="query"
          label="Busque aqui"
          variant="outlined"
          value={query}
          onChange={handleChangeQuery}
        />
      </Grid>
      <Grid item>
        <FormControl variant="outlined" sx={{ minWidth: 120 }}>
          <InputLabel id="bondLabel">Vínculo</InputLabel>
          <Select
            labelId="bondLabel"
            id="bondSelect"
            label="Vínculo"
            value={bond}
            onChange={handleChangeBond}
          >
            <MenuItem value="internal">Interno</MenuItem>
            <MenuItem value="external">Externo</MenuItem>
            <MenuItem value="">Ambos</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item>
        <Button
          size="large"
          sx={{ minHeight: 56, color: '#FFF' }}
          onClick={() => getVetsCb(true)}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
};
